import { FieldType, FormNode, FormOpenMode, NumericFieldDefinition } from '@msdk/definitions'
import React, { ReactElement } from 'react'

import { ConditionalFieldContainer } from '../Fields/ConditionalFieldContainer'
import { CustomField } from '../Fields/CustomField'
import { ReadonlyAttachmentField } from './ReadonlyAttachmentField'
import { ReadonlyField } from './ReadonlyField'
import { ReadonlyListField } from './ReadonlyListField'

interface Props {
  type: FieldType
  node: FormNode
  divider?: boolean
  inList?: boolean
  className?: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const emptyOnChange = () => {}
const defaultArgs = { formOpenMode: FormOpenMode.Readonly }

export function ConditionalReadonlyFieldRenderer(props: Props) {
  const renderReadonlyField = (um?: string) => (
    <ReadonlyField node={props.node} divider={props.divider} um={um} inList={props.inList} />
  )

  const renderer: Record<FieldType, ReactElement> = {
    Attachment: <ReadonlyAttachmentField node={props.node} divider={props.divider} inList={props.inList} />,
    Bag: renderReadonlyField(),
    Custom: <CustomField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    DateTime: renderReadonlyField(),
    DateTimeUnknown: renderReadonlyField(),
    Duration: renderReadonlyField(),
    Image: <ReadonlyAttachmentField node={props.node} divider={props.divider} inList={props.inList} />,
    List: <ReadonlyListField node={props.node} divider={props.divider} inList={props.inList} />,
    Lookup: renderReadonlyField(),
    Numeric: renderReadonlyField((props.node.value.fieldDefinition as NumericFieldDefinition)?.um),
    OptionSet: renderReadonlyField(),
    String: renderReadonlyField(),
    MultiSelector: renderReadonlyField(),
    MetadataSelector: renderReadonlyField(),
    Time: renderReadonlyField(),
    AnyOf: renderReadonlyField(),
    CodeableConcept: renderReadonlyField(),
  }

  const classNames = ['ConditionalField-renderer', 'readonly', props.className].filter(Boolean).join(' ')

  return (
    <ConditionalFieldContainer className={classNames}>
      {props.node.value.visibility !== 'Invisible' && renderer[props.type]}
    </ConditionalFieldContainer>
  )
}
